import { LIST_PERMISSION, SAVE_MOBILE_VIEW, SAVE_PERMISSION, SAVE_SUB_GROUPS, SAVE_USER_DETAILS } from "../type.action";

export const userPermission = (values) => ({
  type: SAVE_PERMISSION,
  values,
});

export const getUserPermission = () => ({
  type: LIST_PERMISSION,
});

export const saveMobileView = (values) => ({ type: SAVE_MOBILE_VIEW, values });

export const saveUserDetails = (userDetails) => ({
  type: SAVE_USER_DETAILS,
  values: userDetails,
});
export const saveSubGroups = (subGroups) => ({
  type: SAVE_SUB_GROUPS,
  values: subGroups,
});
